import {SET_SHOPIFY_MODE, UPDATE_SHOPIFY_MODE_SETTINGS} from "../actions";
import {Record} from "immutable";

class ShopifyModeState extends Record({
  shopifyMode: false,
  shopifySettings: null,
}) {
}

const initialState = new ShopifyModeState();

const ShopifyModeReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_SHOPIFY_MODE:
      return state
        .set('shopifyMode', !!action.shopifyMode);
    case UPDATE_SHOPIFY_MODE_SETTINGS:
      return state
        .set('shopifySettings', action.shopifySettings);
    default:
  }

  return state;
};

export const name = 'shopifyMode';
export const selector = (state) => state[name];
export default ShopifyModeReducer;
